if (typeof Connect == 'undefined') Connect = { contextRoot: '/connect' };


Connect.IntegrationTransaction = Backbone.Model.extend({

});

Connect.IntegrationTransactions = Backbone.Collection.extend({
    model: Connect.IntegrationTransaction,
    url: function() {
        var url;
        if (this.groupUuid && this.application && this.searchQuery && this.seachQuery != "ALL")
            url = Connect.contextRoot + "/transaction/list/"+this.groupUuid+"/application/"+this.application+"/"+this.searchQuery;
        else if (this.groupUuid && this.application)
            url = Connect.contextRoot + "/transaction/list/"+this.groupUuid+"/application/"+this.application;
        else if (this.groupUuid)
            url = Connect.contextRoot + "/transaction/list/"+this.groupUuid;
        else if (this.application)
            url = Connect.contextRoot + "/transaction/list/application"+this.application;
        else
            throw 'No path for integration transactions';
        if (this.filterParams)
            url += "?" + $.param(this.filterParams);
        return url;


    },
    initialize: function(models, options) {
        if (options) {
            this.groupUuid = options.groupUuid;
            this.application = options.application;
            this.filterParams = options.filterParams;
            this.searchQuery = options.searchQuery;
        }
    },

    getCount: function(includeFailed) {
        if (this.searchQuery && this.searchQuery != "ALL") {
            var url = Connect.contextRoot + "/transaction/list/"+this.groupUuid+"/"+this.application+"/"+this.searchQuery+"/count";
        } else {
            var url = Connect.contextRoot + "/transaction/list/"+this.groupUuid+"/"+this.application+"/count";
        }
        var params = JSON.parse(JSON.stringify(this.filterParams))
        params.includeFailed = !!includeFailed;
        if (this.filterParams)
            url += "?" + $.param(params);

        return $.get(url);
    }
});
